import { render, staticRenderFns } from "./TourTabsPricing.vue?vue&type=template&id=72631d86&scoped=true&"
import script from "./TourTabsPricing.vue?vue&type=script&lang=js&"
export * from "./TourTabsPricing.vue?vue&type=script&lang=js&"
import style0 from "./TourTabsPricing.vue?vue&type=style&index=0&id=72631d86&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72631d86",
  null
  
)

export default component.exports